import { useLayoutEffect, useState } from 'react';

import PropTypes from 'prop-types';

import Tooltip from '#globalComponents/Tooltip/Tooltip';
import TooltipPanel from '#globalComponents/Tooltip/TooltipPanel';

/**
 * Single-line text that ellipsizes and reveals the full text in a tooltip — only while it is
 * actually cut off, so short values never get a redundant hover panel.
 */
export default function TruncatedText({ text, className = '' }) {
	const [node, setNode] = useState(null);
	const [isTruncated, setIsTruncated] = useState(false);

	useLayoutEffect(() => {
		if (!node) return undefined;
		const measure = () => setIsTruncated(node.scrollWidth > node.clientWidth);
		measure();
		const observer = new ResizeObserver(measure);
		observer.observe(node);
		return () => observer.disconnect();
	}, [node, text]);

	return (
		<Tooltip content={isTruncated ? <TooltipPanel>{text}</TooltipPanel> : null} className="flex min-w-0">
			<span ref={setNode} className={`block min-w-0 truncate ${className}`}>
				{text}
			</span>
		</Tooltip>
	);
}

TruncatedText.propTypes = {
	text: PropTypes.string.isRequired,
	className: PropTypes.string,
};
